import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import Popover from "module-common/Popover";

export default class Tooltip extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    text: PropTypes.string,
    position: PropTypes.oneOf(["top", "bottom", "left", "right"])
  };
  static defaultProps = { position: "top" };

  render() {
    const { children, text, position, ...rest } = this.props;
    return (
      <Popover
        {...rest}
        show="enter"
        hide="leave"
        position={position}
        content={
          <Tip position={position}>
            <Text>{text}</Text>
          </Tip>
        }
      >
        {children}
      </Popover>
    );
  }
}

const Tip = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  border-radius: 4px;
  background-color: ${props => props.theme.tooltip};
  box-shadow: ${props => props.theme.shadow};
  user-select: none;

  &:after {
    content: " ";
    position: absolute;
    border: 10px solid;
  }

  ${props => {
    switch (props.position) {
      case "bottom":
        return css`
          &:after {
            bottom: 100%;
            border-color: transparent transparent #20445a transparent;
          }
        `;
      case "left":
        return css`
          &:after {
            left: 100%;
            border-color: transparent transparent transparent #20445a;
          }
        `;
      case "right":
        return css`
          &:after {
            right: 100%;
            border-color: transparent #20445a transparent transparent;
          }
        `;
      case "top":
      default:
        return css`
          &:after {
            top: 100%;
            border-color: #20445a transparent transparent transparent;
          }
        `;
    }
  }};
`;

const Text = styled.span`
  white-space: pre;
  font-size: 0.8rem;
  color: white;
  line-height: 1.5;
`;



// WEBPACK FOOTER //
// ./src/module-common/Tooltip.js